import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '../../definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'risk-profil-first-part-form',
    templateUrl: './risk-profil-first-part-form.component.html',
    styleUrls: ['./risk-profil-first-part-form.component.scss'],
    standalone: false
})
export class RiskProfilFirstPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options1: FormControlOption[] = [
    {
      value: 'SINGLE',
      label: 'Célibataire',
      suffix: { title: 'A' },
    },
    {
      value: 'IN_A_RELATIONSHIP',
      label: 'En couple',
      suffix: { title: 'B' },
    },
  ];
  options2: FormControlOption[] = [
    {
      value: 'OWNER',
      label: 'Propriétaire',
      suffix: { title: 'A' },
    },
    {
      value: 'TENANT',
      label: 'Locataire',
      suffix: { title: 'B' },
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
